import script from "./caseDetailEN.vue?vue&type=script&setup=true&name=caseDetailEN&lang=js"
export * from "./caseDetailEN.vue?vue&type=script&setup=true&name=caseDetailEN&lang=js"

import "./caseDetailEN.vue?vue&type=style&index=0&id=0769686a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0769686a"]])

export default __exports__